module["exports"] = ["ბ-ნი", "ბატონი", "ქ-ნი", "ქალბატონი"];